<template>
  <div class="flex flex-col items-start">
    <NText variant="caption1" class="whitespace-pre-line">
      {{
        t('orders.riskAnnouncement.message', {
          orderType:
            orderType === 'conditional'
              ? t('orders.conditional.conditionalTradingُ')
              : t('orders.offlineOrderTitle'),
        })
      }}
    </NText>

    <NButton
      size="mini"
      variant="flat"
      color="gray"
      class="mt-2 !rounded-full"
      @click="getAgreementText"
    >
      <NegarDownloadIcon
        size="16"
        class="text-neutral-secondary mx-auto cursor-pointer ml-1"
      />

      <NText variant="overline" weight="medium" class="text-neutral-secondary">
        {{ t('agreement.downloadAgreementText') }}
      </NText>
    </NButton>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { NegarDownloadIcon } from '@negar/icons';
import { useGetAgreementText } from '@core/user';
import { ALGORITHM_RISK_AGREEMENT_ID } from '@core/order';
import { download } from '@libs/utils';

type OrderRiskAnnouncementDialogPropsType = {
  orderType: 'conditional' | 'offline';
};

defineProps<OrderRiskAnnouncementDialogPropsType>();

const { t } = useI18n();

const { getAgreementText } = useGetAgreementText({
  id: ref(ALGORITHM_RISK_AGREEMENT_ID),
  onSuccess(result) {
    download(result.data.title, result.data.attachment);
  },
});
</script>
